const EDITABLE_SHEET_EXTENSIONS = ['xlsx', 'xls', 'csv'];

/** True when the file name looks like a spreadsheet we can open in the editor. */
export const isEditableSheetFile = (fileName?: string): boolean => {
    const ext = fileName?.split('.').pop()?.toLowerCase() ?? '';
    return EDITABLE_SHEET_EXTENSIONS.includes(ext);
};

/**
 * Minimum Fortune-Sheet row height (px), applied as a floor — never shrinks a
 * row that's already taller. Fortune-Sheet's own built-in default is 19px,
 * which renders too short; named `_ROW_` (not `_CELL_`) so a sibling
 * `MIN_COLUMN_WIDTH` can be added later without a rename.
 */
export const MIN_ROW_HEIGHT = 24;
